import React, { CSSProperties, FC, ReactNode } from 'react';
import { css } from '@emotion/css';
import useTheme from 'evcharging/hooks/useTheme';
import { Theme } from 'evcharging/app/themes';
import clsx from 'clsx';

type Variant = 'h1' | 'h2';

interface BigTitleProps extends CSSProperties {
  children: ReactNode;
  variant?: Variant;
}

const BigTitle: FC<BigTitleProps> = (props) => {
  const theme = useTheme();
  const { children, variant = 'h1', ...cssProps } = props;
  const styles = createStyles(theme);

  return variant === 'h1' ? (
    <h1 className={clsx(styles.root, css({ ...cssProps }))}>{children}</h1>
  ) : (
    <h2 className={clsx(styles.root, css({ ...cssProps }))}>{children}</h2>
  );
};

const createStyles = (theme: Theme) => ({
  root: css`
    font-weight: 500;
    font-size: 48px;
    line-height: 62px;
    color: #252c32;
    ${theme.breakpoints.mobile.down} {
      font-size: 32px;
      line-height: 150%;
    }
  `,
});

export default BigTitle;
